export type DataLayerPayload = Record<string, unknown>;

export const pushToDataLayer = (payload: DataLayerPayload) => {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(payload);
};
